var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:url(#radial-gradient-2);}.cls-3{fill:url(#radial-gradient-3);}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#fff;}.cls-7,.cls-8{opacity:0.4;isolation:isolate;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 3.59,
    cy: -72.32,
    r: 21.1,
    gradientTransform: "matrix(0.63, 0, 0, -0.7, 5.93, -37.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#bee8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7bd0f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#46bdeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#20afe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09a7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00a4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0970b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123884"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 30.68,
    cy: -84.01,
    r: 9.52,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -1.21,
    cy: -84.11,
    r: 24.19,
    gradientTransform: "matrix(0.63, 0, 0, -0.7, 5.93, -37.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fef3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fcd69c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#faaf40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ef7a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e23d21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.58,
    y1: -60.26,
    x2: 14.14,
    y2: -81.9,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -60.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#e3f6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9cdef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2cb9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00aae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#0076b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004891"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 33.42,
    y1: -77.92,
    x2: 24.35,
    y2: -86.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 12.34,
    y1: -60.46,
    x2: 11.98,
    y2: -82.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 30.14,
    y1: -80.96,
    x2: 27.28,
    y2: -83.59,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.4,19.66A8,8,0,0,1,15.55,12,7.23,7.23,0,0,1,20,13.23c7.11,4,4.18-11.61-2.67-13.08a6.45,6.45,0,0,0-7.07,3.46L.9,21.19c-2.47,4.65.42,10.4,5.21,10.8a4.26,4.26,0,0,0,4.19-4.51c0-2.87-2.16-3.83-1.9-7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.63,20.3a8.77,8.77,0,0,1-1.4,4.79,4.94,4.94,0,0,0,1.35,6.15,4,4,0,0,0,2.31.76,6.26,6.26,0,0,0,3.68-1.6,7.66,7.66,0,0,0,1.53-9.21c-2.57-4.83-7.48-5.8-7.48-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.39,23.65a5.28,5.28,0,0,0,7,2c4.63-2.54,1.5-7.1,5.6-9.54,2.44-1.47,3.77.73,5.74-1.17a3.37,3.37,0,0,0,.82-3.47,2.91,2.91,0,0,0-5.69.52c-.64,3.23-4,4.05-6.51,3a5.1,5.1,0,0,0-5.27.22,6.26,6.26,0,0,0-1.92,8,4,4,0,0,0,.2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1.34,27.43a6.91,6.91,0,0,1,.13-6.23L10.81,3.62A5.9,5.9,0,0,1,16,.37c7.21,0,10.41,16,4.33,11.9A7.84,7.84,0,0,0,15.5,11a8.64,8.64,0,0,0-7.76,8.29c-.27,4.08,1.55,4.68,1.91,7.38.62,4.54-5.72,6.24-8.32.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.78,25.11a9.43,9.43,0,0,0,1.5-5.17c0-6.59,9.6.78,6.39,7.49-3,6.25-10.42,3-7.88-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.23,18.87a5.25,5.25,0,0,1,4-4.13c2.59-.45,4.11,2.16,7.68.32a4.51,4.51,0,0,0,2.62-3.3A2.26,2.26,0,0,1,30,11.38a2.52,2.52,0,0,1-1.28,3.11c-1.36.64-2.91-.52-5,.81-2.38,1.49-2.48,4.91-3.28,7-2,5-10.47,3.1-9.15-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4.49,23.34c0-8.23,6.19-15.11,13.61-15.11A12.05,12.05,0,0,1,23.48,9.5C23,5.77,20.19.37,16,.37a5.9,5.9,0,0,0-5.19,3.25L1.47,21.2a6.91,6.91,0,0,0-.13,6.23C2.55,30,4.57,31,6.32,30.82A16,16,0,0,1,4.49,23.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M25.06,17.68a16.13,16.13,0,0,1,1.59,13.11,5.47,5.47,0,0,0,4-3.36C33.31,21.9,27.27,15.93,25.06,17.68Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/Asset.bfa2724b9f39d3046efe048cc5384f09.svg";
export { ForwardRef as ReactComponent };